import { Shirt, CupSoda } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const TypeSelect = ({ value, onChange }) => {
  const { t } = useLang();
  const opts = [
    { id: "dtf", icon: Shirt, title: t("types.dtf"), sub: t("types.dtf_for"), ring: "border-ruby bg-ruby/10" },
    { id: "uvdtf", icon: CupSoda, title: t("types.uv"), sub: t("types.uv_for"), ring: "border-cap bg-cap/10" },
  ];
  return (
    <div className="grid grid-cols-2 gap-3">
      {opts.map(({ id, icon: Icon, title, sub, ring }) => (
        <button
          key={id}
          type="button"
          data-testid={`transfer-type-${id}`}
          aria-pressed={value === id}
          onClick={() => onChange(id)}
          className={`flex items-center gap-3 rounded-md border-2 p-4 text-left transition-colors ${value === id ? ring : "border-white/10 hover:border-white/30"}`}
        >
          <Icon className="h-7 w-7 shrink-0" />
          <span>
            <span className="block font-extrabold">{title}</span>
            <span className="block text-xs text-slate-400">{sub}</span>
          </span>
        </button>
      ))}
    </div>
  );
};
